const getAttendeeContactExternalIds = event => {
  const enrollments = event?.enrollments ?? []

  return enrollments
    .filter(enrollment => !enrollment.isCanceled)
    .flatMap(enrollment =>
      (enrollment.student?.representatives ?? []).map(
        representative => representative.contact?.externalId,
      ),
    )
    .filter(Boolean)
}

const getWaitlistContactExternalIds = event => {
  const entries = event?.waitlist?.entries ?? []

  return entries.map(entry => entry.contact?.externalId).filter(Boolean)
}

const resolveGroupEventMessagingRecipients = (
  event,
  { includeAttendees, includeWaitlist },
) => {
  const recipientIds = []

  if (includeAttendees) {
    recipientIds.push(...getAttendeeContactExternalIds(event))
  }

  if (includeWaitlist) {
    recipientIds.push(...getWaitlistContactExternalIds(event))
  }

  return Array.from(new Set(recipientIds))
}

const getAudienceOptions = event => {
  const attendeeCount = getAttendeeContactExternalIds(event).length
  const waitlistCount = getWaitlistContactExternalIds(event).length

  return {
    attendees: {
      available: attendeeCount > 0,
      count: attendeeCount,
      defaultChecked: attendeeCount > 0,
    },
    waitlist: {
      available: waitlistCount > 0,
      count: waitlistCount,
      defaultChecked: false,
    },
  }
}

export {
  getAttendeeContactExternalIds,
  getWaitlistContactExternalIds,
  resolveGroupEventMessagingRecipients,
  getAudienceOptions,
}
